import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ViewerLayoutWrap, PDFWrap, PdfEdit } from '@ohif/ui';
import type { MenuProps } from 'antd';
import { useAppConfig } from '@state';
import { Spin, Dropdown } from 'antd';
import userSvg from './images/user.svg';
import { utils } from '@ohif/core';
const { apiService } = utils;

const CompactMainWrap: React.FC = () => {
  const [activeTab, setActiveTab] = useState('viewer'); // 控制当前活动的 Tab
  const [iframeUrl, setIframeUrl] = useState<any>('');
  const [pdfIframeUrl, setPdfIframeUrl] = useState<any>('');
  const [appConfig] = useAppConfig();
  const [studies, setStudies] = useState([]);
  const [ListLoading, setListLoading] = useState(false);
  const [href, setHref] = useState<string>('');
  const [studyState, setStudyState] = useState<string>('');
  const [register_key, setRegister_key] = useState<string>('');
  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <Link
          to="/"
          onClick={() => sessionStorage.removeItem('user')}
        >
          <span>退出</span>
        </Link>
      ),
    },
  ];

  useEffect(() => {
    //http://localhost:3000/pacscompact?register_time_begin=2021-03-02 00:00:00&register_time_end=2025-03-26 00:00:00
    //获取地址栏的参数
    const url = window.location.href;
    setHref(window.location.origin);
    const params = new URLSearchParams(new URL(url).search);
    const filterValues = {};
    for (const [key, value] of params.entries()) {
      filterValues[key] = value;
    }
    getData(filterValues);
  }, []);

  //获取检查列表数据
  const getData = (params?) => {
    const formData = new FormData();
    if (params) {
      for (const i in params) {
        formData.append(i, params[i]);
      }
    }

    setListLoading(true);
    apiService({
      uri: '/api/reglist/stream-page',
      method: 'POST',
      data: formData,
      type: null,
    })
      .then(res => {
        if (res?.Data) {
          setListLoading(false);
          const length = res.Data.length;
          let data = res.Data;
          data = data.map((item, index) => {
            item.index = (params.currentPage - 1) * params.pageSize + index + 1;
            return item;
          });
          let normalizedData = normalizeDataIndex(data, true);
          normalizedData = normalizedData.map(item => {
            if (item.state === '0') {
              item.stateText = '待检查';
            } else if (item.state === '1') {
              item.stateText = '待诊断';
            } else if (item.state === '2') {
              item.stateText = '已诊断';
            } else if (item.state === '3' || item.state === '4' || item.state === '5') {
              item.stateText = '已审核';
            }
            return item;
          });
          setStudies(normalizedData);
        }
      })
      .catch(res => {
        setListLoading(false);
        console.log('请求检查列表报错', res);
      });
  };

  const normalizeDataIndex = (data, toLowerCase = true) => {
    const normalizedData = data.map(item => {
      const normalizedItem = {};
      Object.keys(item).forEach(key => {
        const normalizedKey = toLowerCase ? key.toLowerCase() : key.toUpperCase();
        normalizedItem[normalizedKey] = item[key];
      });
      return normalizedItem;
    });
    return normalizedData;
  };

  //切换标签页
  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };

  //获取StudyInstanceUid
  const getStudyInstanceUid = (register_key) => {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('register_key', register_key);
      // 请求接口获取检查科室
      apiService({
        uri: '/api/reglist/getSuid',
        method: 'POST',
        data: formData,
      })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          console.log('请求报错', err);
          reject(err);
        });
    });
  };

  //点击查看按钮
  const handleClickStudy = async study => {
    const studyinstanceuid = await getStudyInstanceUid(study.register_key)
    if (!studyinstanceuid) {
      return;
    }
    const uidArr = studyinstanceuid.split(';');
    let uidStr = '';
    uidArr.map(item => {
      uidStr += '&StudyInstanceUIDs=' + item;
    });
    const currentState = study.state;
    setStudyState(currentState);
    setRegister_key(study.register_key);

    let viewerUrl = '';
    let shouldShowPdf = false;

    if (study.modality_code === 'SM') {
      viewerUrl = href + '/microscopy?' + uidStr.slice(1);
      shouldShowPdf = Number(currentState) >= 3;
    } else {
      viewerUrl = href + '/viewer?' + uidStr.slice(1);
      shouldShowPdf = Number(currentState) >= 3;
    }

    if (activeTab === 'pdf') {
      // 如果当前是报告预览，影像内容要显示
      setIframeUrl(viewerUrl);
      if (shouldShowPdf) {
        const newPdfUrl =
          // appConfig.pacsUrl +
          '/ncpacsservice/reportPicServlet?reg_key=' + study.register_key + '&output=pdfbyte';
        setPdfIframeUrl(newPdfUrl);
      } else {
        setPdfIframeUrl('');
      }
    } else if (activeTab === 'viewer') {
      setIframeUrl(viewerUrl);
      if (shouldShowPdf) {
        const newPdfUrl =
          // appConfig.pacsUrl +
          '/ncpacsservice/reportPicServlet?reg_key=' + study.register_key + '&output=pdfbyte';
        setPdfIframeUrl(newPdfUrl);
      } else {
        setPdfIframeUrl('');
      }
    }
  };

  // 添加 CSS 样式
  const styles = {
    truncate: {
      width: '150px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  };

  return (
    <div className="compact_main_wrap flex">
      <Spin spinning={ListLoading}>
        <ul className="flex h-screen w-[300px] flex-col overflow-y-auto bg-[#2f343f] pt-[4px]">
          {studies.map(item => {
            const dynamicClass =
              item.register_key === register_key ? 'bg-[#9399a6]' : 'bg-[#5b616f]';
            const combinedClass = `flex justify-between text-white pl-[5px] mt-[4px] mb-[3px] ${dynamicClass}`;
            return (
              <li
                key={item.studyinstanceuid}
                className={combinedClass}
              >
                <div>
                  <div>
                    类型：{item.modality_code}({item.stateText})
                  </div>
                  <div>姓名：{item.chinese_name}</div>
                  <div
                    className="w-[220px] truncate"
                    title={item.bodypart_name}
                  >
                    部位：{item.bodypart_name}
                  </div>
                  <div>日期：{item.register_time}</div>
                </div>
                <div
                  className="flex h-full w-[50px] cursor-pointer items-center justify-center bg-[#7a849b]"
                  onClick={() => handleClickStudy(item)}
                >
                  查看
                </div>
              </li>
            );
          })}
        </ul>
      </Spin>
      <div className="mainwrap-page h-screen grow">
        <div className="header-box">
          <div className="btn-box">
            <div
              className={activeTab === 'viewer' ? 'tab-btn-active' : 'tab-btn'}
              onClick={() => handleTabChange('viewer')}
            >
              影像浏览
            </div>
            <div
              className={activeTab === 'pdf' ? 'tab-btn-active' : 'tab-btn'}
              onClick={() => handleTabChange('pdf')}
            >
              报告预览
            </div>
            {appConfig.isShowPdfEdit && (
              <div
                className={activeTab === 'pdfedit' ? 'tab-btn-active' : 'tab-btn'}
                onClick={() => handleTabChange('pdfedit')}
              >
                报告编辑
              </div>
            )}
          </div>
          <div className="icon-user">
            <Dropdown
              menu={{ items }}
              placement="bottom"
              arrow
            >
              <img
                src={userSvg}
                alt=""
              />
            </Dropdown>
          </div>
        </div>
        <div>
          <div
            style={{
              visibility: activeTab === 'viewer' ? 'visible' : 'hidden',
              height: activeTab === 'worklist' ? '100%' : 0,
            }}
          >
            <ViewerLayoutWrap iframeUrl={iframeUrl} />
          </div>
          <div
            style={{
              visibility: activeTab === 'pdf' ? 'visible' : 'hidden',
              height: activeTab === 'worklist' ? '100%' : 0,
            }}
          >
            <PDFWrap iframeUrl={pdfIframeUrl} />
          </div>
          {appConfig.isShowPdfEdit && (
            <div
              style={{
                display: activeTab === 'pdfedit' ? 'block' : 'none',
                height: activeTab === 'worklist' ? '100%' : 0,
              }}
            >
              <PdfEdit />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompactMainWrap;
